import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { PageLevelNotification } from '@americanexpress/dls-react';
import { IconWifiOff } from '@americanexpress/dls-icons';

import styles from './OfflineWarning.scss';

const OfflineWarning = () => {
  const [hidden, setHidden] = useState(null);

  const showWarning = () => setHidden(false);
  const hideWarning = () => setHidden(true);

  useEffect(() => {
    window.addEventListener('online', hideWarning);
    window.addEventListener('offline', showWarning);

    return () => {
      window.removeEventListener('online', hideWarning);
      window.removeEventListener('offline', showWarning);
    };
  }, []);

  const offline = global.BROWSER && (navigator.onLine === false);

  if (!offline || hidden) {
    return null;
  }

  return (
    <aside className={styles.offlineWarning} data-testid="offline-warning">
      <PageLevelNotification
        type="caution"
        aria-live="polite"
        icon={(<IconWifiOff isFilled={true} />)}
      >
        <p>
          <FormattedMessage
            id="offlineWarning"
            defaultMessage="You are not connected to the internet. Some experiences may not work as expected."
          />
        </p>
      </PageLevelNotification>
    </aside>
  );
};

export default OfflineWarning;
